/** @ngInject */
class SelectNDSController {
  constructor($scope) {
    this.$scope = $scope
  }

  $onInit() {
    // перечень возможных значений НДС
    this.ndsopts = [0, 5, 7, 18, 20, 22].map((value, idx) => ({
      id: this.mode === '%' ? `${value / 100}` : '' + value,
      name: `${value}%`,
    }))
    // опция для варианта "не облагается"
    this.emptyVal = this.emptyValue === undefined ? '' : this.emptyValue
    this.ndsopts.splice(0, 0, { id: this.emptyVal, name: 'н/о' })

    this.ngModel.$render = this._$parse.bind(this)
    this.$scope.$watch(() => this.model, this._$format.bind(this))
    this.$scope.$watch(() => this.ndsMode, this._$format.bind(this))
  }

  _$parse() {
    const vv = this.ngModel.$viewValue
    if (vv !== undefined && String(vv).startsWith('+')) {
      this.model = String(vv).slice(1)
      this.ndsMode = '+'
    } else {
      this.model = String(vv)
      this.ndsMode = ''
    }
  }

  _$format() {
    let value = this.model
    if (this.ndsMode === '+' && value !== this.emptyVal) {
      value = '+' + value
    }
    this.ngModel.$setViewValue(value)
  }
}

export const SelectNDSComponent = {
  template: require('./select-nds.component.html'),
  styles: [require('./select-nds.component.scss')],
  bindings: {
    mode: '@?',
    emptyValue: '@?',
  },
  require: {
    ngModel: '^ngModel',
  },
  controller: SelectNDSController,
  controllerAs: 'vm',
}
